import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-trainer-popup',
  templateUrl: './trainer-popup.page.html',
  styleUrls: ['./trainer-popup.page.scss'],
})
export class TrainerPopupPage implements OnInit {
  storeOfferCards :any;
  constructor(public modalCtrl: ModalController,) { }

  ngOnInit() {
  }
  ionViewWillEnter() {
    console.log("checking",this.storeOfferCards);
    
  }

  modeSelected(data) {
    console.log("hoc", data);
    this.modalCtrl.dismiss({
      // packdet: tr_pack,
      selectedMode: data,
     
    });
    // console.log(tr_pack_id);
  }


}
